import {
  InputLabel as MantineInputLabel,
  InputLabelProps,
} from '@mantine/core';

export type IInputLabelProps = InputLabelProps;

/** @registry Design-layer pass-through over Mantine InputLabel; import this instead of @mantine/core InputLabel outside src/design. */
export const InputLabel = MantineInputLabel;
